import React from 'react';
import Textinput from './textinput';

import { browserHistory } from 'react-router';
import { isEveryValid, isEmailValid } from '../services/utils';

class ForgotPopup extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            forgotEmail: '',
            submitCliked: false,
            validation: {
                forgotEmail: false
            }
        }
    }

    closePopup(e) {
        //Protect from closing on mobile device
        let isMobile = window.innerWidth <= 768;
        if (e.target.getAttribute('name') == 'forgotPopup' && !isMobile) {
            this.props.hidePopup();
            browserHistory.push('/');
        }
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        let stateProps ={
            [name]: value
        };

        this.setState(stateProps, () => { this.validateField(name, value) });
    }

    handleSubmit() {
        let isValid = isEveryValid(this.state.validation);

        this.setState({
            submitCliked: true
        });

        if (isValid) {
            if (this.state.forgotEmail) {
                this.props.resetPassword(this.state.forgotEmail);
            }
        }
    }

    validateField(fieldName, value) {
        value = isEmailValid(value);

        this.setState({
            validation: {
                ...this.state.validation,
                [fieldName]: value ? true : false
            }
        });

    }

    renderPopupBody() {
        let { title, content, buttonText, large, buttonAction } = this.props;

        let isValid = this.state.forgotEmail ? true : false;

        return (
            <div className='form'>
                <h1 className='popup-title'>Enter your email address!</h1>
                <div className='popup-content'>
                    <Textinput
                        label='Email'
                        name='forgotEmail'
                        value={ this.state.forgotEmail }
                        onChange={ this.handleChange.bind(this) }
                        required={true}
                        invalid={!this.state.validation.forgotEmail && this.state.submitCliked}
                        type='email' />
                </div>

                <div className='popup-buttons'>
                    <button
                        onClick={ this.handleSubmit.bind(this) }
                        className='button button-block popup-button'>
                        REQUEST RESET
                    </button>
                </div>
            </div>
        );

    }

	render() {
        return (
            <div name='forgotPopup' className='forgot-container generic-popup-container'
                onClick={ this.closePopup.bind(this) }
                style={{display: this.props.visible ? 'block' : 'none' }}>

                { this.renderPopupBody() }

            </div>
        )
    }
}

export default ForgotPopup;



// WEBPACK FOOTER //
// ./source/components/forgotPopup.js